import { DBEntity, VIPCapability, IVIPCapability } from "@/loader";

/**
 * Capability Datebase Class Logic.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * Do not modify it because it will be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		1.2.2
 * @since		1.0.0
 */
export class VIPCapabilityDB extends DBEntity<IVIPCapability, VIPCapability> {
	public getter(a: VIPCapability, id: number): boolean {
		return a && id && a.id === id || false;
	}

	public create(data: IVIPCapability): VIPCapability {
		return new VIPCapability(data);
	}

	public match(a: VIPCapability, b: VIPCapability | IVIPCapability): boolean {
		return a && b && a.id === b.id || false;
	}

	public is(item: any): item is VIPCapability {
		return item && item instanceof VIPCapability;
	}
}
